// utils/numberToWords.js
export function numberToWords(num) {
    const single = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

    if (typeof num !== 'number' || isNaN(num)) {
        return 'Invalid Number';
    }

    // Handle decimal amounts
    let dollars = Math.floor(num);
    let cents = Math.round((num - dollars) * 100);

    if (dollars === 0 && cents === 0) return 'Zero';

    function convertLessThanOneThousand(n) {
        if (n === 0) return '';
        let current = '';

        const hundreds = Math.floor(n / 100);
        const remainder = n % 100;

        if (hundreds > 0) {
            current += single[hundreds] + ' Hundred';
        }

        if (remainder > 0) {
            if (current !== '') current += ' ';

            if (remainder < 10) {
                current += single[remainder];
            } else if (remainder >= 10 && remainder < 20) {
                current += teens[remainder - 10];
            } else {
                current += tens[Math.floor(remainder / 10)];
                if (remainder % 10 > 0) {
                    current += ' ' + single[remainder % 10];
                }
            }
        }

        return current;
    }

    let result = '';
    const billion = Math.floor(dollars / 1000000000);
    dollars %= 1000000000;
    const million = Math.floor(dollars / 1000000);
    dollars %= 1000000;
    const thousand = Math.floor(dollars / 1000);
    dollars %= 1000;

    if (billion > 0) {
        result += convertLessThanOneThousand(billion) + ' Billion';
    }

    if (million > 0) {
        if (result !== '') result += ' ';
        result += convertLessThanOneThousand(million) + ' Million';
    }

    if (thousand > 0) {
        if (result !== '') result += ' ';
        result += convertLessThanOneThousand(thousand) + ' Thousand';
    }

    if (dollars > 0) {
        if (result !== '') result += ' ';
        result += convertLessThanOneThousand(dollars);
    }

    if (cents > 0) {
        if (result !== '') result += ' and ';
        result += convertLessThanOneThousand(cents) + ' Cents';
    }

    return result.replace(/\s+/g, ' ');
}
